module.exports = __webpack_public_path__ + "img/logo.5cb37d19.svg";